module.exports = __webpack_public_path__ + "img/cavalier-challenge-2-2x_0a9f3dcd9e86a9cd9296631745a10dff.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/cavalier-challenge-2-2x.jpg
// module id = 266
// module chunks = 0